import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleZoneRemoval(
  state: State,
  { uuid }: Boundaries["removeZone"]["success"],
): State {
  return {
    ...state,
    projects: state.projects.filter(({ zone }) => zone.uuid !== uuid),
  };
}

export { handleZoneRemoval };
